export default __webpack_public_path__ + "static/media/manual-mottekite.03e9a870.png";